import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import isMobile from 'ismobilejs';
import Parallax from 'parallax-scroll';

const selectors = {
	el: '.js-main-page',
	entrance: {
		trigger: '.js-entrance-trigger',
		cards: '.js-entrance-cards'
	},
	about: {
		image: '.js-about-img'
	}
};

const states = {
	entrance: {
		visible: 'main__entrance_visible'
	}
};

const entrance = () => document.querySelector(selectors.entrance.trigger);


const aboutParallax = () => {
	const parallax = new Parallax(selectors.about.image, {
		speed: 0.1
	});
	parallax.animate();
};

const checkIfInView = (el, offset = 0) => {
	const rect = el.getBoundingClientRect();
	const elTop = rect.top + pageYOffset;
	return pageYOffset >= elTop - offset;
};

const onScroll = item => () => {
	if (checkIfInView(item, 300)) {
		item.classList.add(states.entrance.visible);
	}
};

const onLoad = () => {
	if (isMobile.any) {
		document.documentElement.classList.add('mobile');
	}
};

const setHandlers = () => {
	bindEvent('window', 'scroll', onScroll(entrance()));
};

const render = () => {
	bindEvent('window', 'load', onLoad);
	if (isElement(selectors.el) && !isViewport(lg) && !isMobile.any) {
		aboutParallax();
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/main/index.js